import React, { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { SectionHeading } from "./Section";
import { Reveal } from "../../lib/ui-motion";
import { useLang } from "../../i18n";

export const About = () => {
  const { t } = useLang();
  const a = t.about;
  const [active, setActive] = useState(0);

  return (
    <section id="about" className="relative py-24 md:py-36" data-testid="about-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <SectionHeading overline={a.overline} title={a.title} sub={a.lead} />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3 lg:gap-x-20">
          <div className="relative">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-white/10" />
            {a.items.map((item, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <button
                  onMouseEnter={() => setActive(i)}
                  onClick={() => setActive(i)}
                  data-cursor="hover"
                  data-testid={`about-item-${i}`}
                  className="group relative flex items-start gap-5 w-full text-left py-4"
                >
                  <span className={`relative z-10 mt-1.5 h-3.5 w-3.5 rounded-full border-2 transition-all duration-300 ${active === i ? "border-flame bg-flame scale-110" : "border-white/30 bg-[#050505]"}`} />
                  <span className={`font-heading text-2xl md:text-3xl font-bold transition-colors duration-300 ${active === i ? "text-white" : "text-white/35 group-hover:text-white/70"}`}>
                    {item.t}
                  </span>
                </button>
              </Reveal>
            ))}
          </div>

          <div className="relative">
            <div className="md:sticky md:top-32">
              <motion.div
                key={active}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="relative rounded-3xl border border-white/10 bg-ink-surface p-8 md:p-12 overflow-hidden"
              >
                <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-flame/10 blur-3xl" />
                <span className="font-mono text-7xl md:text-8xl font-bold text-flame/20 leading-none">
                  {String(active + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-6 font-heading text-3xl md:text-4xl font-bold">{a.items[active].t}</h3>
                <p className="mt-4 text-lg text-white/60 leading-relaxed max-w-md">{a.items[active].d}</p>
                <Plus className="absolute right-8 bottom-8 text-flame/40" size={28} />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
